import { DataTable as $ } from './DataTable.js';
import { DataTableBody } from './DataTableBody.js';
import { DataTableCell } from './DataTableCell.js';
import { DataTableFooter } from './DataTableFooter.js';
import { DataTableHeader } from './DataTableHeader.js';
import { DataTableHeaderCell } from './DataTableHeaderCell.js';
import { DataTablePaginationSelector } from './DataTablePaginationSelector.js';
import { DataTableScroller } from './DataTableScroller.js';
import { DataTableViewport } from './DataTableViewport.js';

export * from './utils/index.js';
export * from './hooks/index.js';
export * from './DataTableHeader.js';
export * from './DataTableHeaderCell.js';
export * from './DataTableCell.js';
export * from './DataTableBody.js';
export * from './DataTableFooter.js';
export * from './DataTableScroller.js';
export * from './DataTableViewport.js';
export * from './DataTablePaginationSelector.js';
export * from './DataTableTypes.js';
export * from './DataTable.js';

export const DataTable = Object.assign($, {
  Header: DataTableHeader,
  HeaderCell: DataTableHeaderCell,
  Cell: DataTableCell,
  Body: DataTableBody,
  Footer: DataTableFooter,
  Scroller: DataTableScroller,
  Viewport: DataTableViewport,
  PaginationSelector: DataTablePaginationSelector,
});
